import { render, staticRenderFns } from "./study-participants-details-new.vue?vue&type=template&id=79bb7f30&scoped=true&"
import script from "./study-participants-details-new.vue?vue&type=script&lang=js&"
export * from "./study-participants-details-new.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=79bb7f30&scoped=true&lang=scss&"
import style1 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=1&id=79bb7f30&scoped=true&lang=scss&"
import style2 from "@/assets/dropdown-css.scss?vue&type=style&index=2&id=79bb7f30&scoped=true&lang=scss&"
import style3 from "@/assets/participant-profile.scss?vue&type=style&index=3&id=79bb7f30&scoped=true&lang=scss&"
import style4 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=4&id=79bb7f30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb7f30",
  null
  
)

component.options.__file = "study-participants-details-new.vue"
export default component.exports